<template>
  <a-drawer :title="`表单设置-${form.name}`" :maskClosable="true" width="100%" placement="right" :closable="true"
    @close="close" :visible="visible">

    <a-row :gutter="12">
      <a-col :span="14">
        <div style="margin-bottom: 10px">
          <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
          <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
          <a-button @click="handleAddMy" type="primary" icon="plus" style="float: right;">新增</a-button>
        </div>

        <!-- table区域-begin -->
        <div>
          <a-table ref="table" size="middle" bordered rowKey="id" :columns="columns" :dataSource="dataSource"
            :pagination="ipagination" :loading="loading" class="j-table-force-nowrap" @change="handleTableChange">
            <span slot="action" slot-scope="text, record">
              <a @click="handleEditMy(record)">编辑</a>
              <a-divider type="vertical" />
              <a-dropdown>
                <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                      <a>删除</a>
                    </a-popconfirm>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>

          </a-table>
        </div>
      </a-col>
      <a-col :span="10">
        <a-spin :spinning="confirmLoading">
          <a-form-model layout="horizontal" :model="model" v-bind="{ labelCol: { span: 6 }, wrapperCol: { span: 18 }, }"
            ref="ruleForm" :rules="rules">
            <a-form-model-item label="ID">
              <a-input readOnly v-model="model.id" />
            </a-form-model-item>
            <a-form-model-item prop="code" label="元素代码">
              <a-input placeholder="请输入元素代码" v-model="model.code" />
            </a-form-model-item>
            <a-form-model-item prop="number" label="题号">
              <a-input :rows="2" placeholder="请输入题号" v-model="model.number" />
            </a-form-model-item>
            <a-form-model-item prop="name" label="题目">
              <a-textarea :rows="2" placeholder="请输入题目" v-model="model.name" />
            </a-form-model-item>

            <a-form-model-item prop="required" label="必填">
              <a-radio-group v-model="model.required">
                <a-radio value="1">是</a-radio>
                <a-radio value="0">否</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="题目图片">
              <j-image-upload class="avatar-uploader" text="上传" v-model="model.img"
                :bizPath="`knowledge/form/${form.id}`"> </j-image-upload>
            </a-form-model-item>
            <a-form-model-item label="需要用户画图">
              <a-radio-group v-model="model.draw">
                <a-radio value="1">是</a-radio>
                <a-radio value="0">否</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item prop="scale" label="量表元素">
              <a-radio-group v-model="model.scale">
                <a-radio value="1">是</a-radio>
                <a-radio value="0">否</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item prop="conceal" label="隐藏元素">
              <a-radio-group v-model="model.conceal">
                <a-radio value="1">是</a-radio>
                <a-radio value="0">否</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item prop="disabled" label="禁止输入">
              <a-radio-group v-model="model.disabled">
                <a-radio value="1">是</a-radio>
                <a-radio value="0">否</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item prop="sortNum" label="排序">
              <a-input-number v-model="model.sortNum" :min="0" :precision="0" style="width: 100%" placeholder="请输入排序" />
            </a-form-model-item>
            <a-form-model-item prop="parentCode" label="依赖项">
              <a-tree-select v-model="model.parentCode" :replaceFields="replaceFields" :tree-data="itemTreeData"
                show-search allowClear style="width: 100%" :filterTreeNode="filterTreeNode"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择依赖项" tree-default-expand-all
                @change="itemTreeChange">
              </a-tree-select>
            </a-form-model-item>
            <a-form-model-item v-if="model.parentCode" label="依赖项值">
              <a-select placeholder="请选择依赖项值" v-model="model.parentValueList" mode="multiple" @change="$forceUpdate()">
                <a-select-option v-for="(item, index) in parentDictItems" :key="index" :value="item.value">{{ item.text
                  }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item prop="description" label="描述">
              <a-textarea :rows="2" placeholder="请输入描述" v-model="model.description" />
            </a-form-model-item>
            <a-form-model-item prop="inputTip" label="引导语">
              <a-textarea :rows="2" placeholder="请输入引导语" v-model="model.inputTip" />
            </a-form-model-item>
            <a-form-model-item label="元素类型" prop="type">
              <a-select placeholder="请选择" v-model="model.type">
                <a-select-option :value="item.value" v-for="(item, index) in elementTypeData" :key="index">{{ item.text
                  }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="允许小数点" v-if="model.type === 'number'">
              <a-radio-group v-model="model.reDecimal">
                <a-radio value="1">是</a-radio>
                <a-radio value="0">否</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="数据最大长度" v-if="['text','textarea','slider','number'].indexOf(model.type)>=0" >
              <a-input-number v-model="model.length" :min="0" :precision="0" style="width: 100%"/>
            </a-form-model-item>
            <a-form-model-item label="数据最小长度" v-if="['text','textarea','slider','number'].indexOf(model.type)>=0" >
              <a-input-number v-model="model.minLength" :min="0" :precision="0" style="width: 100%"/>
            </a-form-model-item>
            <a-form-model-item label="单位" v-if="['text','number','textarea','slider'].indexOf(model.type)>=0">
              <a-input v-model="model.unit" placeholder="单位" />
            </a-form-model-item>
            <a-form-model-item label="校验正则" v-if="['text', 'number', 'textarea'].indexOf(model.type) >= 0">
              <a-input v-model="model.checkReg" placeholder="校验正则" />
            </a-form-model-item>
            <a-form-model-item v-if="['check', 'select'].indexOf(model.type) >= 0" prop="dictItemJson" label="选项配置">
              <a-row :gutter="5">
                <a-col :span="8">
                  <a-button size="small" type="primary" icon="plus" @click="handleAddDictItem()">添加自定义</a-button>
                </a-col>
                <a-col :span="8">
                  <a-button size="small" type="primary" icon="plus" @click="handleAddDictItem()">引用上一题</a-button>
                </a-col>
                <a-col :span="8">
                  <a-button size="small" type="primary" icon="plus" @click="handleAddDictItem()">引用其他题目</a-button>
                </a-col>
              </a-row>
              <a-row :gutter="5">
                <a-col :span="10">选项内容</a-col>
                <a-col :span="3">选项值</a-col>
                <a-col :span="3">映射值</a-col>
                <a-col :span="3">排序</a-col>
                <a-col :span="3">图片</a-col>
                <a-col :span="2">
                </a-col>
              </a-row>
              <a-row :gutter="5" v-for="(dictItem, index) in currentDictItems" :key="index">
                <a-col :span="10">
                  <a-input v-model="dictItem.text"></a-input>
                </a-col>
                <a-col :span="3">
                  <a-input v-model="dictItem.value"></a-input>
                </a-col>
                <a-col :span="3">
                  <a-input v-model="dictItem.mappingValue"></a-input>
                </a-col>
                <a-col :span="3">
                  <a-input v-model="dictItem.sortNum"></a-input>
                </a-col>
                <a-col :span="3">
                  <j-image-upload class="avatar-uploader" text="上传" v-model="dictItem.img"
                    :bizPath="`knowledge/form/${form.id}/answser`"> </j-image-upload>
                </a-col>
                <a-col :span="2">
                  <a-button size="small" type="primary" icon="delete" @click="handleDeleteDictItem(index)">
                  </a-button>
                </a-col>
              </a-row>
            </a-form-model-item>
            <div style="text-align: right">
              <a-button type="primary" :loading="confirmLoading" style="margin-left: 30px"
                @click="handleSubmit">保存</a-button>
            </div>
          </a-form-model>
        </a-spin>
      </a-col>
    </a-row>
  </a-drawer>
</template>

<script>
import '@assets/less/TableExpand.less'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { deleteAction, getAction, postAction } from '@api/manage'
import { elementTypeData } from '@/constants/project'
import baseRules from '@/constants/baseRules'
import JImageUpload from '@comp/jeecg/JImageUpload'

export default {
  name: "TempConfigFormItemSet",
  mixins: [JeecgListMixin],
  components: { JImageUpload },
  data() {
    return {
      description: '项目配置-知识库-表单元素管理页面',
      form: {},
      model: {},
      rules: {
        number: [{}],
        code: [baseRules.required],
        elementId: [baseRules.required],
        sortNum: [baseRules.required],
        name: [baseRules.required],
        parentValueList: [baseRules.requiredChange],
        required: [baseRules.requiredChange],
        scale: [baseRules.requiredChange],
        conceal: [baseRules.requiredChange],
        disabled: [baseRules.requiredChange],
        type: [baseRules.requiredChange],
      },
      confirmLoading: false,
      elementTypeData: elementTypeData,
      visible: false,
      replaceFields: { children: 'children', title: 'name', key: 'code', value: 'code' },
      // 表头
      columns: [
        {
          title: '名称',
          align: "left",
          dataIndex: 'name'
        },
        {
          title: '表单题号',
          width: 100,
          align: "center",
          dataIndex: 'number'
        },
        {
          title: '排序',
          align: "center",
          width: 80,
          dataIndex: 'sortNum'
        },

        // {
        //   title: '描述',
        //   ellipsis: true, //表格省略
        //   align:"center",
        //   dataIndex: 'description'
        // },
        {
          title: '操作',
          dataIndex: 'action',
          width: 100,
          align: "center",
          scopedSlots: { customRender: 'action' },
        }
      ],
      url: {
        list: "/tempconfig/tempConfigFormItem/list",
        delete: "/tempconfig/tempConfigFormItem/delete",
      },
      itemTreeData: [],
      parentDictItems: [],
      currentDictItems: [],
    }
  },
  computed: {
  },
  watch: {
    dataSource() {
      this.itemTreeData = JSON.parse(JSON.stringify(this.dataSource))
      this.handleEditMy(this.model || {})
    }
  },
  mounted() {
  },
  methods: {
    handleSubmit() {
      const that = this;
      // 触发表单验证
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          //校验字典是否合法
          let formData = JSON.parse(JSON.stringify(this.model));
          if (formData.type == 'select' || formData.type == 'check') {
            if (this.currentDictItems.length == 0) {
              return this.$message.error('请配置完成选项内容')
            }
            let hasError = false
            this.currentDictItems.forEach(dictItem => {
              if (!(dictItem.text && dictItem.value)) {
                hasError = true
              }
              if (dictItem.sortNum == null || dictItem.sortNum == undefined) {
                hasError = true
              }
            })
            if (hasError) {
              return this.$message.error('请配置完成选项内容')
            }
            formData.dictItemJson = JSON.stringify(this.currentDictItems)
          }
          if (formData.parentValueList && formData.parentValueList.length > 0) {
            formData.parentValue = formData.parentValueList.join(',')
          }
          if(!formData.parentCode){
            formData.parentCode = ''
          }
          that.confirmLoading = true;
          postAction('/tempconfig/tempConfigFormItem/save', formData).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              if (!formData.id) {
                let sortNum = this.model.sortNum;
                this.model.sortNum = sortNum + 1
              }
              this.loadData()
              // this.handleCancel()
            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        } else {
          return false;
        }
      })
    },
    handleAddMy() {
      this.handleEditMy({
        formCode: this.form.code,
        parentCode: '',
        parentValue: '',
        sortNum: 0,
        name: '',
        number: '',
        required: '0',
        disabled: '0',
        scale: '0',
        conceal: '0',
        description: '',
        code: '',
        type: 'text',
        length: null,
        unit: '',
        reDecimal: '1',
        checkReg: '',
        dictItemJson: '',
      })
    },
    loadDataCallback() {
      this.handleAddMy()
    },
    handleEditMy(record) {
      const model = JSON.parse(JSON.stringify(record))
      //console.log("dictItemJson:" + model.dictItemJson)
      if (model.dictItemJson) {
        this.currentDictItems = JSON.parse(model.dictItemJson)
      }
      this.model = model
      this.$set(this.model, 'draw', (this.model.draw || 0) + "")

      this.unDisabledAll(this.itemTreeData)
      if (this.model.id) {
        this.coppyId = ''
        this.disabledNode(this.itemTreeData, this.model.code, false)
        this.itemTreeChange()
      }
      if (this.model.parentValue) {
        // this.$set(this.model,'parentValueList',this.model.parentValue.split(','))
        this.$set(this.model, 'parentValueList', this.model.parentValue.split(','))
        // this.model.parentValueList =
      } else {
        this.$set(this.model, 'parentValueList', [])
      }
    },
    disabledNode(nodeList, code, disabledChildren) {
      if (!nodeList || nodeList.length === 0) {
        return
      }
      if (disabledChildren) {
        nodeList.forEach(node => {
          node.disabled = true
          if (node.children) {
            this.disabledNode(node.children, code, true)
          }
        })
      } else {
        nodeList.forEach(node => {
          if (node.code === code) {
            node.disabled = true
            if (node.children) {
              this.disabledNode(node.children, code, true)
            }
          }
          else {
            if (node.children) {
              this.disabledNode(node.children, code, false)
            }
          }
        })
      }
    },
    unDisabledAll(nodeList) {
      if (!nodeList || nodeList.length === 0) {
        return
      }
      nodeList.forEach(node => {
        node.disabled = false
        if (node.children) {
          this.unDisabledAll(node.children)
        }
      })
    },
    handleAddDictItem() {
      this.currentDictItems.push({
        text: '',
        value: ''
      })
    },
    handleDeleteDictItem(index) {
      this.$confirm({
        title: '提示',
        content: '您确定要删除吗？',
        centered: false,
        onOk: () => {
          this.currentDictItems.splice(index, 1)
        },
      })
    },
    onLoadTreeData(treeNode) {
      return new Promise((resolve) => {
        const parentNodeData = treeNode.dataRef
        this.onLoadTreeDataAction(parentNodeData, resolve)
      })
    },
    getItemByCode(code, dataList) {
      if (!dataList || dataList.length === 0) {
        return
      }
      for (let i = 0; i < dataList.length; i++) {
        let node = dataList[i]
        if (node.code == code) {
          return node.dictItemJson
        }
        if (node.children) {
          let json = this.getItemByCode(code, node.children)
          if (json) {
            return json
          }
        }
      }
      return
    },
    itemTreeChange() {
      this.model.parentValueList = []
      if (this.model.parentCode) {
        this.parentDictItems = JSON.parse(this.getItemByCode(this.model.parentCode, this.dataSource))
        // 处理字典项
      } else {
        this.model.parentValueList = []
        this.parentDictItems = []
      }
    },
    view(form) {
      this.parentDictItems = []
      this.currentDictItems = []
      this.form = form
      this.baseQueryParam = {
        formCode: form.code
      }
      this.handleAddMy()
      this.loadData();
      this.visible = true
    },
    close() {
      this.visible = false
      this.$emit('ok')
    },
    filterTreeNode(inputValue, treeNode) {
      return treeNode.data.props.title && treeNode.data.props.title.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
    },
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>